// generated by genversion
const productionVersion = "0.0.8";
const uatVersion = "0.0.8";

export default {
  productionVersion,
  uatVersion,
};
